import format from 'date-fns/format';
import { NOT_APPLICABLE, WIR_DATE_FORMAT } from 'pages/WellGuardian/WIR/wir.constants';
import { ScheduleWIR, WIRListPresentation } from 'types/wellGuardian';

export const getLastWirActivity = (wir?: WIRListPresentation | ScheduleWIR) =>
  wir?.lastUpdatedDate ? format(new Date(wir.lastUpdatedDate), WIR_DATE_FORMAT) : NOT_APPLICABLE;
